<template>
  <basic-container>
    <div>
      <button @click="playOnce" v-show="false">点击</button>
      <audio ref="audioElement" src="https://health-planet.oss-cn-shanghai.aliyuncs.com/1755139107976_%E6%8A%A5%E8%AD%A6%E9%93%83%E5%A3%B0.mp3"></audio>
    </div>

    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="(page) => onLoad(page, params)"
      @row-update="updateRecord"
      :row-style="rowStyle"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"></template>
      <template slot-scope="scope" slot="map">
        <el-button type="text" size="small" @click="toMap(scope.row)" v-if="scope.row.alarm_type === 1 || scope.row.alarm_type === 2">查看地图</el-button>
      </template>
      <template slot="menu" slot-scope="{ row, index }" v-if="row.response_time === undefined">
        <el-button type="text" size="small" @click="view(row, index)">确认查看</el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getLocalAlarm, setReponseTime, updateRecord } from "@/api/health/manage";
import func from "@/util/func";
export default {
  data() {
    return {
      fullscreenLoading: false,
      params: {},
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      headerCellClassName: "headerClass",
      option: {
        indexLabel: "序号",
        tip: false,
        border: false,
        index: true,
        viewBtn: true,
        editBtn: true,
        addBtn: false,
        delBtn: false,
        selection: false,
        searchSpan: 4,
        labelWidth: 130,
        menuWidth: 140,
        searchEnter: true,
        searchMenuSpan: 4,
        column: [
          {
            label: "报警类型",
            prop: "alarm_type",
            search: true,
            type: "select",
            dicData: [
              { label: "SOS报警", value: 1 },
              { label: "跌倒报警", value: 2 },
              { label: "SOS报警", value: 3 },
            ],
            detail: true,
          },
          {
            label: "触发时间",
            prop: "alarm_date",
            width: 190,
            detail: true,
          },
          // {
          //   label: "报警级别",
          //   prop: "mobile",
          //   search: true,
          // },
          {
            label: "关联设备ID",
            prop: "imei",
            search: true,
            width: 140,
            searchLabelWidth: 100,
            detail: true,
          },
          {
            label: "用户信息",
            prop: "name",
            search: true,
            detail: true,
          },
          {
            label: "电话",
            prop: "phone",
            search: true,
            detail: true,
          },
          {
            label: "紧急联系人信息",
            prop: "urgent_account",
            width: 120,
            search: true,
            searchLabelWidth: 120,
            detail: true,
          },
          {
            label: "紧急联系人电话",
            prop: "urgent_phone",
            width: 120,
            detail: true,
          },
          // {
          //   label: "处理人员",
          //   prop: "doc",
          //   search: true,
          // },
          {
            label: "首次响应时间",
            prop: "response_time",
            width: 150,
            detail: true,
          },
          {
            label: "后续跟踪记录",
            prop: "record",
            overHidden: true,
          },
          {
            label: "后续跟踪记录响应时间",
            prop: "record_time",
            overHidden: true,
            width: 150,
          },
          {
            label: "定位",
            prop: "map",
            detail: true,
            viewDisplay: false,
            editDisplay: false,
          },
        ],
      },
      data: [],
    };
  },
  methods: {
    onLoad(page, params) {
      console.log("onload?");
      const wxUserId = window.localStorage.getItem("pcUserId");
      // 渠道参数
      params.channel = window.localStorage.getItem("channel");
      getLocalAlarm(page.currentPage, page.pageSize, params).then((res) => {
        if (wxUserId === "2043870969731301377" && res.data.alarm.length > 0) {
          res.data.alarm.forEach((item) => {
            item.urgent_account = func.maskPhone(item.urgent_account);
            item.name = func.maskName(item.name);
          });
        }

        this.page.total = res.data.total;
        this.data = res.data.alarm;
        console.log(res.data.alarm);
        if (res.data.count !== "0") this.playOnce();
      });

      if (this.timer == null) {
        this.startTimer();
      }
    },

    updateRecord(row, index, done, loading) {
      console.log("row.record:", row.record);
      if (row.id == null) {
        done();
        this.$message.success("数据未修改!");
        return;
      }
      updateRecord(row)
        .then((res) => {
          done();
          this.onLoad(this.page, this.params);
          this.$message.success("修改成功!");
        })
        .catch(() => {
          this.onLoad(this.page, this.params);
        });
    },

    rowStyle({ row, rowIndex }) {
      if (row.response_time === undefined) {
        return {
          color: "#1890ff",
        };
      }
    },

    view(row, index) {
      setReponseTime(row.id).then((res) => {
        this.onLoad(this.page);
      });
    },

    myTask() {
      const wxUserId = window.localStorage.getItem("pcUserId");
      getLocalAlarm(this.page.currentPage, this.page.pageSize, this.params).then((res) => {
        if (wxUserId === "2043870969731301377" && res.data.alarm.length > 0) {
          res.data.alarm.forEach((item) => {
            item.urgent_account = func.maskPhone(item.urgent_account);
            item.name = func.maskName(item.name);
          });
        }

        this.page.total = res.data.total;
        this.data = res.data.alarm;
        if (res.data.count !== "0") this.playOnce();
      });
    },

    startTimer() {
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(this.myTask, 30000);
    },

    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    beforeDestroy() {
      this.stopTimer();
    },

    searchChange(params, done) {
      console.log("SeachChange?");
      this.params = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },

    selectionChange(list) {
      this.selectionList = list;
    },

    searchReset() {
      this.params = {};
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm);
    },

    toMap(row) {
      console.log(row);
      const parameter = {
        gps: row.gps,
        detail: row.detail,
        name: row.name,
        date: row.alarm_date,
        type: row.alarm_type,
      };
      const routeData = this.$router.resolve({
        path: "/mapShow",
        query: parameter,
      });
      window.open(routeData.href, "_blank");
    },

    playOnce() {
      const audio = this.$refs.audioElement;
      // audio.currentTime = 0; // 初始0秒
      audio.loop = false; // 不循环
      audio.play().catch((e) => {
        console.log("播放失败:", e);
        this.remind();
      });
    },

    remind() {
      const loading = this.$loading({
        lock: true,
        text: "请点击屏幕任意区域，开启铃声",
        spinner: "el-icon-message-solid",
        background: "rgba(0, 0, 0, 0.7)",
      });

      const closeLoading = () => {
        loading.close();
        document.removeEventListener("click", closeLoading); // 移除监听
      };
      document.addEventListener("click", closeLoading);
    },
  },
};
</script>
<style>
.headerClass {
  background-color: #409eff !important;
  color: #fff !important;
}
</style>
